import { Link } from "react-router-dom";
import RenderImage from "./RenderImage";
import { cn } from "../../utils/cn";

const LogoComponent = ({
  src,
  alt,
  link,
  width,
  height,
  padding,
  gap,
  className,
  imageClassName,
  onClick,
  rounded,
  objectFit,
  placeholderImage,
  fallbackSrc,
}) => {
  return (
    <div
      className={cn("flex items-center", className)}
      style={{
        padding,
        gap: `${gap}px`,
      }}
      onClick={onClick}
    >
      <Link
        to={link}
        className="flex items-center"
        style={{ width: `${width}px`, height: `${height}px` }}
      >
        <RenderImage
          src={src}
          alt={alt}
          rounded={rounded}
          objectFit={objectFit}
          fallbackSrc={fallbackSrc}
          placeholderImage={placeholderImage}
        />
      </Link>
    </div>
  );
};

export default LogoComponent;
